import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  table: {
    display: 'block',
    overflowX: 'auto',
    position: 'relative',
    'thead tr th': {
      borderBottom: `1px solid ${theme.colors.gray2[0]}`,
      borderTop: `1px solid ${theme.colors.gray2[0]}`,
    },
    'tbody tr td': {
      borderTop: `1px solid ${theme.colors.gray2[0]}`,
    },
  },
  column: {
    '&:first-of-type': {
      paddingLeft: /* eslint-disable-line local-rules/use-theme-tokens */ '16px',
    },
    '&:last-of-type': {
      paddingRight: /* eslint-disable-line local-rules/use-theme-tokens */ '16px',
      width: '1%',
    },
  },
  sortableColumn: {
    cursor: 'pointer',
    transition: 'all 150ms ease',
    opacity: 1,
    '&:hover': {
      opacity: 0.85,
    },
  },
  tableFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: theme.other.spacing._16,
    width: '100%',
    padding: theme.other.spacing._16,
    borderTop: `1px solid ${theme.colors.gray2[0]}`,
    backgroundColor: theme.white,
  },
}));
